// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"3eefe41a","453":"9abeed03","455":"6a984e14","885":"8efeff3a"}[chunkId] + ".chunk.js";
};